import type { QuestionResult } from '../types'

export function calculateResults(results: QuestionResult[]) {
  const objective = results.filter((item) => item.correct !== null)
  const correctCount = objective.filter((item) => item.correct === true).length
  const incorrectCount = objective.filter((item) => item.correct === false).length
  const percentage = objective.length === 0 ? 0 : Math.round((correctCount / objective.length) * 100)
  const resultsByOA: Record<string, { correct: number; total: number; percentage: number }> = {}

  for (const result of objective) {
    const current = resultsByOA[result.oa] ?? { correct: 0, total: 0, percentage: 0 }
    current.total += 1
    if (result.correct) current.correct += 1
    current.percentage = Math.round((current.correct / current.total) * 100)
    resultsByOA[result.oa] = current
  }
  return { correctCount, incorrectCount, percentage, resultsByOA }
}

export function findWeakestTopic(results: QuestionResult[]): string {
  const counts = new Map<string, number>()
  results.filter((item) => item.correct === false).forEach((item) => counts.set(item.topic, (counts.get(item.topic) ?? 0) + 1))
  return [...counts.entries()].sort((a, b) => b[1] - a[1])[0]?.[0] ?? ''
}

export function createRecommendation(resultsByOA: Record<string, { percentage: number }>, weakestTopic: string): string {
  const entries = Object.entries(resultsByOA)
  if (entries.length === 0) return 'Revisa el material de apoyo y completa la actividad indicada en tu cuaderno.'
  const [weakestOA, data] = entries.sort((a, b) => a[1].percentage - b[1].percentage)[0] ?? ['', { percentage: 0 }]
  if (data.percentage >= 80) return 'Tu desempeño fue sólido. Usa el material de apoyo para profundizar y organizar lo aprendido en tu cuaderno.'
  return `Conviene reforzar ${weakestOA}${weakestTopic ? `, especialmente “${weakestTopic}”` : ''}. Lee el apoyo sugerido y completa la actividad de cuaderno.`
}
